import { PlaceholdersId, TFComponent } from '@types';

import { ConclusionPlaceholder } from './conclusion';

export const conclusion: TFComponent = {
	component: ConclusionPlaceholder,
	id: PlaceholdersId.conclusion,
	name: 'conclusion',
};
